//should be put in env
export const ALERT_VANISH_TIME_MS = 5000;
